import styled from 'styled-components';
export const AvatarContainer = styled.div `
  display: inline-block;
`;
